import { render, staticRenderFns } from "./ModalAgendamento.vue?vue&type=template&id=3be50a71&scoped=true&"
import script from "./ModalAgendamento.vue?vue&type=script&lang=js&"
export * from "./ModalAgendamento.vue?vue&type=script&lang=js&"
import style0 from "./ModalAgendamento.vue?vue&type=style&index=0&id=3be50a71&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be50a71",
  null
  
)

export default component.exports